export const mockData = {
  hero: {
    title: "Welcome to FITNOVEXA",
    subtitle: "Transform Through Technology",
    description: "Bridging Traditional Fitness & Recreation with Next-Generation Solutions",
    cta: "Schedule Consultation"
  },
  
  services: [
    {
      id: 1,
      title: "Innovative Fitness Products",
      description: "Proprietary fitness apps, personal training systems, and digital coaching platforms designed to revolutionize how you train.",
      icon: "Smartphone"
    },
    {
      id: 2,
      title: "Digital Fitness & Recreation Consulting",
      description: "Transform your fitness business with cutting-edge technology. Virtual assessments, digital transformation strategies, and system optimization.",
      icon: "Laptop"
    },
    {
      id: 3,
      title: "Online Learning Platform",
      description: "FITNOVEXA Academy offers self-paced courses, masterclasses, and live webinars on fitness technology and business development.",
      icon: "GraduationCap"
    },
    {
      id: 4,
      title: "Tech-Enhanced Recreation Programs",
      description: "Learning Management Systems, digital screen solutions, and efficiency-boosting tech that makes recreation processes faster and easier.",
      icon: "Zap"
    }
  ],
  
  metrics: [
    { value: "20+", label: "Years of Experience" },
    { value: "10,000+", label: "Professionals Trained" },
    { value: "60%", label: "Average Efficiency Improvement" },
    { value: "500+", label: "Successful Implementations" }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Fitness Center Director",
      content: "FITNOVEXA transformed our entire operation. The system upgrades they recommended increased our efficiency by 65% and member satisfaction has never been higher.",
      rating: 5
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Recreation Program Manager",
      content: "Oz Altun, PhD expertise in recreation technology is unmatched. The digital solutions implemented by FITNOVEXA have streamlined our programs and saved countless hours.",
      rating: 5
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      role: "Corporate Wellness Coordinator",
      content: "The consulting services exceeded expectations. FITNOVEXA's approach to integrating technology with wellness programs created measurable improvements in employee engagement.",
      rating: 5
    }
  ],
  
  founderInfo: {
    name: "Oz Altun, PhD",
    title: "Founder & CEO",
    degree: "Doctorate in Sport Management",
    specialization: "Physical Activity Intervention and Promotion Technologies",
    experience: "20+ years",
    bio: "Oz Altun, PhD is a pioneer in integrating technology with fitness and recreation systems. With over two decades of experience, he has led the transformation of countless fitness businesses and recreation centers through innovative technology solutions. His research and implementations have set industry standards for digital fitness transformation and system optimization.",
    credentials: [
      "Doctorate in Sport Management",
      "Specialization in Physical Activity Intervention Technologies",
      "20+ Years Industry Experience",
      "Technology Innovation Awards",
      "Published Research in Fitness Technology"
    ]
  },
  
  consultingServices: [
    "Virtual Fitness Assessments",
    "Digital Transformation for Fitness Businesses",
    "Corporate Wellness Solutions",
    "Recreation Technology Implementation",
    "Performance Optimization Strategies",
    "System Upgrade Consulting"
  ],
  
  academyCourses: [
    "Self-Paced Personal Trainer Courses",
    "Exercise Technique Masterclasses",
    "Recreation Technology Training",
    "Fitness Business Development",
    "System Optimization Workshops",
    "Live Webinars on Fitness Tech Trends"
  ],
  
  recreationSolutions: [
    "Learning Management Systems for Recreation Training",
    "Digital Screen Solutions for Sustainability",
    "Efficiency Enhancement Technologies"
  ],
  
  products: [
    "Proprietary Fitness Apps",
    "Personal Training Sales & Promotion Systems",
    "Digital Screen Platforms",
    "Digital Coaching Platforms"
  ]
};